import { useState, useEffect } from 'react';
import axios from 'axios';

const useFetch = (url, token) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!url) {
        setData(null);
        setError(null);
        setLoading(false);
        return;
      }

      setLoading(true);
      setError(null);

      try {
        const response = await axios.get(url, {
          headers: {
            Authorization: `Basic ${token}`,
          },
        });
        setData(response.data);
      } catch (err) {
        setError(err.message || "An error occurred");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url, token]); 

//   //Console.log(data);

  return { data, loading, error }; 
};

export default useFetch;